import {action, Action, thunk, Thunk} from 'easy-peasy';
import {StoreModel} from "~/store";
import {API} from "~/app/routes";
import {fetch, fetchCancel} from "~/store/commonStore";
import {AllTenantListItem, AllUsers, Department} from "~/types";
import { appReferenceRepository } from '~/data/repositories';

export interface AppDataModel {
    users: AllUsers[]
    fetchingUsers: boolean
    setFetchingUsers: Action<AppDataModel, boolean>
    fetchUsers: Thunk<AppDataModel, void, any, StoreModel, Promise<AllUsers[]>>
    fetchUsersCancel: Action<AppDataModel>
    fetchedUsers: Action<AppDataModel, AllUsers[]>

    departments: Department[]
    fetchingDepartments: boolean
    setFetchingDepartments: Action<AppDataModel, boolean>
    fetchDepartments: Thunk<AppDataModel, void, any, StoreModel, Promise<Department[]>>
    fetchDepartmentsCancel: Action<AppDataModel>
    fetchedDepartments: Action<AppDataModel, Department[]>

    allTenants: AllTenantListItem[]
    fetchingAllTenants: boolean
    setFetchingAllTenants: Action<AppDataModel, boolean>
    fetchAllTenants: Thunk<AppDataModel, void, any, StoreModel, Promise<AllTenantListItem[]>>
    fetchAllTenantsCancel: Action<AppDataModel>
    fetchedAllTenants: Action<AppDataModel, AllTenantListItem[]>

}

export const appDataModel: AppDataModel = {
    users: [],
    fetchingUsers: false,
    setFetchingUsers: action((state, payload) => {
        state.fetchingUsers = payload;
    }),
    fetchUsers: thunk(async (actions) => {
        actions.setFetchingUsers(true);
        try {
            const data = await appReferenceRepository.loadUsers();
            data && actions.fetchedUsers(data);
            return data || [];
        } finally {
            actions.setFetchingUsers(false);
        }
    }),
    fetchUsersCancel: action(() => {
        fetchCancel('Operation canceled by the user');
    }),
    fetchedUsers: action((state, payload) => {
        state.users = payload;
    }),

    departments: [],
    fetchingDepartments: false,
    setFetchingDepartments: action((state, payload) => {
        state.fetchingDepartments = payload;
    }),
    fetchDepartments: thunk(async (actions) => {
        actions.setFetchingDepartments(true);
        try {
            const data = await appReferenceRepository.loadDepartments();
            data && actions.fetchedDepartments(data);
            return data || [];
        } finally {
            actions.setFetchingDepartments(false);
        }
    }),
    fetchDepartmentsCancel: action(() => {
        fetchCancel('Operation canceled by the user');
    }),
    fetchedDepartments: action((state, payload) => {
        state.departments = payload;
    }),

    allTenants: [],
    fetchingAllTenants: false,
    setFetchingAllTenants: action((state, payload) => {
        state.fetchingAllTenants = payload;
    }),
    fetchAllTenants: thunk((actions) => {
        actions.setFetchingAllTenants(true);
        return fetch<AllTenantListItem>(`${API.tenant}/all`)
            .then(data => {
                actions.fetchedAllTenants(data);
                return data;
            })
            .finally(() => {
                actions.setFetchingAllTenants(false);
            });
    }),
    fetchAllTenantsCancel: action(() => {
        fetchCancel('Operation canceled by the user');
    }),
    fetchedAllTenants: action((state, payload) => {
        state.allTenants = payload;
    }),
};
